import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-session-expired-dialog',
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 mat-dialog-title>Session expired</h2>

    <div mat-dialog-content class="text-sm opacity-80">
      Your session expired for security reasons. Please sign in again to continue.
    </div>

    <div mat-dialog-actions align="end">
      <button mat-button (click)="close()">OK</button>
    </div>
  `
})
export class SessionExpiredDialog {
  private ref = inject(MatDialogRef<SessionExpiredDialog>);
  close() {
    this.ref.close(true);
  }
}